import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { firestore } from '../config/firestore'; 
import { Context } from './Appcontext';
 
 
   
export const OrderContext = createContext();


 const OrderContextProvider = ({ children }) => {
     const [order,setOrder]=useState([])
     const {userUid}=useContext(Context)
     
       

 
    useEffect(() => {
        const fetchData = async () => {
          try {
            const querySnapshot = await getDocs(collection(firestore, "UserOrder"));
             
            const orders = querySnapshot.docs.map((doc) => ({
              id: doc.id,  
              ...doc.data(),  
            }));
            setOrder(orders); 

            } catch (error) {
            console.error("Error fetching documents: ", error);
          }
        };
        fetchData();
      }, []);

      const handleDeleteOrder = async (orderId) => {
        try {
          const orderRef = doc(firestore, "UserOrder", orderId);  
          await deleteDoc(orderRef);  
          console.log(`Order ${orderId} deleted successfully.`);
          
           
           
          const updatedOrders = order.filter(order => order.id !== orderId);
          setOrder(updatedOrders);  
        } catch (error) {
          console.error("Error deleting order: ", error);
        }
      };
        let userOrder=order.filter((item=>item.userUid===userUid))
        // console.log("order",order);
        // console.log("userOrder",userOrder);
     
  return (
    <OrderContext.Provider value={{order,setOrder,handleDeleteOrder,userOrder}}>
      {children}
    </OrderContext.Provider>
  );
};

export default OrderContextProvider;

